import gql from 'graphql-tag';

import { PRODUCT_THUMBNAIL, MOBILE_PRODUCT_THUMBNAIL } from '@components/ProductPage/ProductThumbnail/queries';

export const ATTRIBUTE = gql`
  fragment attribute on Attribute {
    id
    slug
    name
    values {
      id
      sortOrder
      name
      slug
    }
  }
`;

export const ATTRIBUTES = gql`
  ${ATTRIBUTE}
  query attributes($inCategory: ID, $inCollection: ID, $query: String) {
    attributes(first: 12, inCategory: $inCategory, inCollection: $inCollection, query: $query) {
      edges {
        node {
          ...attribute
        }
      }
    }
  }
`;

export const PRODUCT_LIST = gql`
  ${PRODUCT_THUMBNAIL}
  query products(
    $first: Int
    $cursor: String
    $sortBy: ProductOrder
    $stockAvailability: StockAvailability
    $attributes: [AttributeScalar]
    $brand: ID
    $brands: [ID]
    $categories: [ID]
    $collections: [ID]
    $tag: ID
    $tags: [ID]
    $types: [ID]
    $query: String
    $voucherCode: String
    $isMgs: Boolean
    $priceLte: Float
    $priceGte: Float
  ) {
    products(
      first: $first
      after: $cursor
      sortBy: $sortBy
      stockAvailability: $stockAvailability
      attributes: $attributes
      brand: $brand
      brands: $brands
      categories: $categories
      collections: $collections
      tag: $tag
      tags: $tags
      types: $types
      query: $query
      voucherCode: $voucherCode
      isMgs: $isMgs
      priceLte: $priceLte
      priceGte: $priceGte
    ) {
      edges {
        node {
          ...productThumbnail
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const MOBILE_PRODUCT_LIST = gql`
  ${MOBILE_PRODUCT_THUMBNAIL}
  query mobileProducts(
    $first: Int
    $cursor: String
    $sortBy: ProductOrder
    $stockAvailability: StockAvailability
    $attributes: [AttributeScalar]
    $brand: ID
    $brands: [ID]
    $categories: [ID]
    $collections: [ID]
    $tag: ID
    $tags: [ID]
    $types: [ID]
    $query: String
    $voucherCode: String
    $isMgs: Boolean
    $priceLte: Float
    $priceGte: Float
  ) {
    products(
      first: $first
      after: $cursor
      sortBy: $sortBy
      stockAvailability: $stockAvailability
      attributes: $attributes
      brand: $brand
      brands: $brands
      categories: $categories
      collections: $collections
      tag: $tag
      tags: $tags
      types: $types
      query: $query
      voucherCode: $voucherCode
      isMgs: $isMgs
      priceLte: $priceLte
      priceGte: $priceGte
    ) {
      edges {
        node {
          ...mobileProductThumbnail
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
